import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AddToCart } from "../shopify/addToCart";
import { CreateCart } from "../shopify/createCart";
import { RemoveFromCart } from "../shopify/removeFromCart";
import { UpdateVariant } from "../shopify/updateVariant";

export const useCartStore = create()(
  persist(
    (set, get) => ({
      id: "",
      lines: [],
      checkoutUrl: "",
      cost: null,
      totalQuantity: 0,
      isLoading: false,
      error: null,
      addItemToCart: async (product) => {
        set({ isLoading: true, error: null });
        try {
          if (get().lines.length > 0) {
            const cart = await AddToCart(get().id, product);
            if (cart.userErrors.length === 0) {
              set((state) => ({
                id: cart.cart.id,
                lines: cart.cart.lines.nodes,
                checkoutUrl: cart.cart.checkoutUrl,
                cost: cart.cart.cost,
                totalQuantity: cart.cart.totalQuantity,
                isLoading: false,
                error: null,
              }));
            }
          } else {
            const cart = await CreateCart(product);
            if (cart.userErrors.length === 0) {
              set((state) => ({
                id: cart.cart.id,
                lines: cart.cart.lines.nodes,
                checkoutUrl: cart.cart.checkoutUrl,
                cost: cart.cart.cost,
                totalQuantity: cart.cart.totalQuantity,
                isLoading: false,
                error: state.error,
              }));
            }
          }
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      updateVariantInCart: async (lineId, merchandiseId, quantity) => {
        set({ isLoading: true, error: null });
        try {
          const cart = await UpdateVariant(
            get().id,
            lineId,
            merchandiseId,
            quantity
          );
          if (cart.userErrors.length === 0) {
            set((state) => ({
              id: cart.cart.id,
              lines: cart.cart.lines.nodes,
              checkoutUrl: cart.cart.checkoutUrl,
              cost: cart.cart.cost,
              totalQuantity: cart.cart.totalQuantity,
              isLoading: false,
              error: null,
            }));
          }
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      removeItemFromCart: async (id) => {
        set({ isLoading: true, error: null });
        try {
          if (get().lines.length > 0) {
            const cart = await RemoveFromCart(get().id, id);
            if (cart.userErrors.length === 0) {
              set((state) => ({
                id: cart.cart.id,
                lines: cart.cart.lines.nodes,
                checkoutUrl: cart.cart.checkoutUrl,
                cost: cart.cart.cost,
                totalQuantity: cart.cart.totalQuantity,
                isLoading: false,
                error: null,
              }));
            }
          }
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      updateQuantity: async (id, quantity) => {
        // Implement update quantity API call and state update
      },
      clearCart: () =>
        set({
          id: "",
          lines: [],
          checkoutUrl: "",
          cost: null,
          totalQuantity: 0,
          isLoading: false,
          error: null,
        }),
    }),
    {
      name: "tranquilobay-cart",
    }
  )
);
